import type { BetterDocConsultationQuestionId } from "@/modules/patients/detail/better-doc/de/lib/better-doc-consultation-questionnaire-definition"

export const getQuestionTestIdPrefix = (questionId: BetterDocConsultationQuestionId) =>
  questionId === "reasonForConsultations"
    ? "reason-for-consultation"
    : questionId
        .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
        .replace(/([A-Z])([A-Z][a-z])/g, "$1-$2")
        .toLowerCase()
